/**
 * The one compact action button of the Automation's sections (19/10/2026,
 * user: "improve the UI/UX of the buttons — professional"): the shared
 * Button, sized to sit beside table rows — 28 px tall, 12 px text, an icon
 * with real breathing room before the label. `primary` for the one action
 * the user should take; otherwise outline.
 * For Media Devoted | Created By Ciro Autiero
 */
import { ComponentProps, FC, ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

import { Button } from '@/components/ui';
import { cn } from '@/lib/utils';

interface Props extends Omit<ComponentProps<typeof Button>, 'size' | 'variant' | 'children'> {
  icon?: LucideIcon;
  children: ReactNode;
  primary?: boolean;
  /** Quieter still: no border until hovered (a "show more" link). */
  quiet?: boolean;
}

export const SectionAction: FC<Props> = ({ icon: Icon, children, primary = false, quiet = false, className, ...rest }) => (
  <Button
    variant={primary ? 'default' : quiet ? 'ghost' : 'outline'}
    size="sm"
    className={cn('h-7 gap-1.5 rounded-md px-2.5 text-xs font-medium', quiet && 'text-primary hover:text-primary', className)}
    {...rest}
  >
    {Icon ? <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden /> : null}
    {children}
  </Button>
);
